module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/star-6105298e8efa2e6042d901aab1366f22.svg";